import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { hexToRGB, Svg, useOsSettings } from '@progress-fe/ui-kit';
import { useToken } from '@chakra-ui/react';
import { MiniMap, Controls, Background, ReactFlow, ControlButton, BackgroundVariant } from '@xyflow/react';
import { ERFEdge, ERFElement } from '../../../enums';
import { RFConnection } from '../../rFlowConnections';
import { GRID_HEX, RF_NODE_TYPES, RF_EDGE_TYPES, RF_FIT_VIEW_MAX_ZOOM, RF_LOGICAL_EDGE_PROPS, RF_DEFAULT_EDGE_PROPS, RF_RECYCLE_EDGE_PROPS } from '../../../constants';
import '@xyflow/react/dist/style.css';
import './RFRender.css';
const RFRenderFC = ({ nodes, edges, onInit, isMinimap, onNodesChange, onEdgesChange, onBeforeDelete, onConnect, onConnectEnd, onReconnect, onSelectNode, onDoubleClickNode, onSelectionStart, onSelectionEnd, onDrop }) => {
    const [isMinimapShown, setIsMinimapShown] = useState(true);
    const { deleteKeyCode } = useOsSettings();
    const onDragOver = useCallback((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    }, []);
    const [bgHex, accentHex] = useToken('colors', ['bg', 'accent']);
    const [shadowHex] = useToken('shadows', ['shadow_1']);
    const mappedEdges = edges.map((edge) => {
        if (edge.type === ERFEdge.Default) {
            return { ...edge, ...RF_DEFAULT_EDGE_PROPS };
        }
        else if (edge.type === ERFEdge.Recycle) {
            return { ...edge, ...RF_RECYCLE_EDGE_PROPS };
        }
        else if (edge.type === ERFEdge.Logical) {
            return { ...edge, ...RF_LOGICAL_EDGE_PROPS };
        }
        else {
            return edge;
        }
    });
    return (_jsxs(ReactFlow, { fitView: true, fitViewOptions: { maxZoom: RF_FIT_VIEW_MAX_ZOOM }, multiSelectionKeyCode: 'Shift', deleteKeyCode: deleteKeyCode, nodes: nodes, edges: mappedEdges, nodeTypes: RF_NODE_TYPES, edgeTypes: RF_EDGE_TYPES, connectionLineComponent: RFConnection, proOptions: { hideAttribution: true }, onInit: onInit, onDrop: onDrop, onNodesChange: onNodesChange, onNodeDoubleClick: (_, node) => onDoubleClickNode?.(node.id), onEdgesChange: onEdgesChange, onConnect: onConnect, onConnectEnd: onConnectEnd, onReconnect: onReconnect, onDragOver: onDragOver, onSelectionStart: onSelectionStart, onSelectionEnd: onSelectionEnd, onBeforeDelete: (inputs) => {
            onBeforeDelete?.(inputs.nodes, inputs.edges);
            return Promise.resolve(false);
        }, children: [_jsx(Controls, { position: "bottom-right", style: { margin: '0 6px 6px 0' }, children: isMinimap && (_jsx(ControlButton, { onClick: () => setIsMinimapShown(!isMinimapShown), children: _jsx(Svg, { name: 'Minimap', size: 's12' }) })) }), _jsx(Background, { variant: BackgroundVariant.Lines, color: GRID_HEX, gap: 50 }), isMinimap && isMinimapShown && (_jsx(MiniMap, { pannable: true, zoomable: true, ariaLabel: '', nodeStrokeWidth: 2, nodeBorderRadius: 6, position: 'bottom-right', maskColor: 'rgba(247, 248, 250, 0.5)', onNodeClick: (_, node) => onSelectNode?.(node.id), style: { boxShadow: shadowHex, borderRadius: '4px', right: '22px', bottom: '-10px' }, nodeStrokeColor: (node) => {
                    if (node.type === ERFElement.GroupDashed)
                        return bgHex;
                    return node.selected ? accentHex : bgHex;
                }, nodeColor: (node) => {
                    if (node.type === ERFElement.GroupDashed)
                        return hexToRGB(bgHex, 0.25);
                    return node.selected ? hexToRGB(accentHex, 0.75) : bgHex;
                } }, `${nodes.length}${edges.length}`))] }));
};
export const RFRender = RFRenderFC;
//# sourceMappingURL=RFRender.js.map